import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var BluetoothOff = createReactComponent("BluetoothOff", ["svg", defaultAttributes, [["path", {
  d: "M17 17l-5 5V12l-5 5",
  key: "17kqnf"
}], ["path", {
  d: "M2 2l20 20",
  key: "131xdx"
}], ["path", {
  d: "M14.5 9.5L17 7l-5-5v4.5",
  key: "1qgx6g"
}]]]);
export default BluetoothOff;